import axios from "axios";
import { useEffect, useState } from "react";
import constantValues from "../Common/ConstantValues";
import { useSelector } from "react-redux";

function useFetch(url, flag) {
  const userPlanData = useSelector((state) => state?.planValidity?.data);
  const [loading, setLoading] = useState(false);
  const [resData, setResData] = useState(null);
  const [catchError, setCatchError] = useState("");
  const [modelWin, setModelWin] = useState(false);
  useEffect(() => {
    if (!url || flag === false) return;

    const tokenType = JSON.parse(sessionStorage.getItem("Tokentype"));
    const token = sessionStorage.getItem("token");

    const headers = {
      Authorization: `${tokenType?.tokenType} ${token}`,
    };

    const fetchData = async () => {
      setLoading(true);
      try {
        let response;
        // Ensure userPlanData is available before filtering
        const filteredData = userPlanData?.filter(item => item.exam1 === "Question Bank") || [];

        if (url === "/getplanvalidity") {
          response = await axios.get(`${constantValues.PGNEET_PROD_URL}${url}`, { headers });
        } else if (filteredData.length > 0) {
          // Only fetch if we have a valid plan ID
          const params = { planId: filteredData[0].id };
          response = await axios.get(`${constantValues.PGNEET_PROD_URL}${url}`, { headers, params });
        }

        if (response) {
          setResData(response.data);
        }
      } catch (error) {
        setModelWin(true);
        setCatchError(error?.response?.data?.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url, flag, userPlanData]);

  return { loading, resData, modelWin, catchError };
}

export default useFetch;
